import { DefaultPrimaryButton, DefaultSecondaryButton, SearchWithFilterInput, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { ProductType } from '@frontend/product/types';
import { FormattedMessage } from 'react-intl';

import KioskList from '../../../components/kiosk-list.component';
import { KioskNavigationFooter } from '../../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../../components/kiosk-navigation-header.component';
import { ProductCard } from '../../../wizard/screens/browse-products-by-categories/product-card/product-card.component';
import { useProductList } from './product-list.controller';

export const ProductList = () => {
    const viewProps = useProductList();

    return (
        <div className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={() => viewProps.navigate(-1)}
            />
            {viewProps.isLoading && (
                <div className='flex flex-1 items-center justify-center p-6'>
                    <Spinner />
                </div>
            )}
            {!viewProps.isLoading && viewProps.hasError && (
                <div className='text-status-danger flex flex-1 items-center justify-center p-6'>
                    {viewProps.error ?? CommonMessage.ERRORS.ENTITY_NOT_FOUND(CommonMessage.OBJECTS.SLOT.DEFAULT)}
                </div>
            )}
            {!viewProps.isLoading && !viewProps.hasError && !!viewProps.slot && (
                <div className='text-foreground-default flex size-full flex-col items-start gap-6 overflow-y-auto p-6 font-medium'>
                    <div className='text-foreground-default justify-start text-lg font-semibold'>{CommonMessage.OBJECTS.STOCK.DEFAULT}</div>
                    <div className='w-full'>
                        <FormattedMessage
                            id='product-list.select-message'
                            defaultMessage='Select your product from the list to add it to the SLOT'
                        />
                    </div>
                    <SearchWithFilterInput
                        filterOptions={[
                            { label: CommonMessage.OBJECTS.ATTRIBUTE.PLURAL, key: 'attribute' },
                            { label: CommonMessage.OBJECTS.PRODUCT.DEFAULT, key: 'search' }
                        ]}
                        placeholder={viewProps.intl.formatMessage({
                            id: 'product-list.search-placeholder',
                            defaultMessage: 'Find by product'
                        })}
                        className='max-h-12'
                        selectedFilterKey={viewProps.searchKey}
                        onChange={viewProps.handleSearchChange}
                    />
                    <KioskList
                        id='product-list'
                        fetch={viewProps.fetch}
                        rowElement={(product) => (
                            <ProductCard
                                key={product.id}
                                variant='attributes'
                                product={product}
                                noImage
                                onClick={() => viewProps.handleProductClick(product)}
                                styles={{ container: `${viewProps.isProductSelected(product) ? 'border-brand-secondary bg-brand-light' : ''}` }}
                            />
                        )}
                    />
                </div>
            )}
            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={() => viewProps.navigate(-1)}
                        disabled={viewProps.isLoading}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={
                            viewProps.selectedProduct?.type === ProductType.EQUIPMENT ? (
                                <FormattedMessage
                                    id='slot-detail.stock.choose-equipment'
                                    defaultMessage='Choose equipment'
                                />
                            ) : (
                                <FormattedMessage
                                    id='slot-detail.stock.add-product'
                                    defaultMessage='Add product'
                                />
                            )
                        }
                        onClick={() => {
                            if (!viewProps.selectedProduct) return;
                            if (viewProps.selectedProduct.type === ProductType.EQUIPMENT) viewProps.handleChooseEquipment();
                            else viewProps.handleProductAdd();
                        }}
                        disabled={!viewProps.selectedProduct || viewProps.isLoading}
                        isLoading={viewProps.isSubmitting}
                    />
                }
            />
        </div>
    );
};
